<script setup lang="ts">
import { trackResponsibleExternalLink } from '~/tracking/responsibleGamingEvents.js'

defineOptions({
	name: 'HelpSection',
})

const { t: $t } = useI18n()

const sendEventExternalLink = ({ link_name, link_url }: any) => {
	trackResponsibleExternalLink({
		link_name,
		link_url,
	})
}
</script>

<template>
	<section class="bg-neutral-50 pb-10 sm:py-24 relative">
		<div class="container relative z-10">
			<div class="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-[955px] mx-auto">
				<div class="border border-success-500 bg-success-50 rounded-xl p-8 min-h-[240px] space-y-9 flex flex-col">
					<div class="flex items-center justify-between">
						<h3 class="text-xl font-semibold text-neutral-900">{{ $t('Gambling Therapy') }}</h3>
						<UButton
							to="https://gamblingtherapy.org/"
							target="_blank"
							icon="ph:arrow-square-out"
							size="sm"
							color="primary"
							square
							variant="ghost"
							class="text-xl shrink-0"
							@click="
								sendEventExternalLink({ link_name: 'Gambling Therapy', link_url: 'https://gamblingtherapy.org/' })
							"
						/>
					</div>
					<p class="text-neutral-700">
						{{
							$t('Offers online support in multiple languages with professional counselors and peer support groups')
						}}.
					</p>
				</div>

				<div
					class="border border-success-500 bg-success-50 rounded-xl p-8 min-h-[240px] space-y-9 flex flex-col justify-center"
				>
					<div class="flex items-center justify-between">
						<h3 class="text-xl font-semibold text-neutral-900">{{ $t('Gamblers Anonymous') }}</h3>

						<UButton
							to="https://jogadoresanonimos.com.pt/"
							target="_blank"
							icon="ph:arrow-square-out"
							size="sm"
							color="primary"
							square
							variant="ghost"
							class="text-xl shrink-0"
							@click="
								sendEventExternalLink({
									link_name: 'JogadoresAnonimos',
									link_url: 'https://jogadoresanonimos.com.pt/',
								})
							"
						/>
					</div>
					<div class="space-y-4">
						<p class="text-neutral-700">
							{{
								$t(
									'A fellowship for sharing experiences and recovery with others who understand the challenges you face',
								)
							}}.
						</p>
						<p class="text-informative-700 font-semibold">{{ $t('Only Portuguese Support Available') }}</p>
					</div>
				</div>

				<div class="border border-success-500 bg-success-50 rounded-xl p-8 min-h-[240px] space-y-9 flex flex-col">
					<div class="flex items-center justify-between">
						<h3 class="text-xl font-semibold text-neutral-900">ICAD</h3>
						<UButton
							to="https://www.icad.pt/ImageContent/Index/21?languageId=0"
							target="_blank"
							icon="ph:arrow-square-out"
							size="sm"
							color="primary"
							square
							variant="ghost"
							class="text-xl shrink-0"
							@click="
								sendEventExternalLink({
									link_name: 'ICAD',
									link_url: 'https://www.icad.pt/ImageContent/Index/21?languageId=0',
								})
							"
						/>
					</div>
					<p class="text-neutral-700">
						{{
							$t(
								'Specialized support and treatment for addictive behaviors through the Linha Vida (1414) and ICAD health teams',
							)
						}}.
					</p>
				</div>

				<div
					class="border border-success-500 bg-success-50 rounded-xl p-8 min-h-[240px] space-y-9 flex flex-col justify-center"
				>
					<div class="flex items-center justify-between">
						<h3 class="text-xl font-semibold text-neutral-900">SIDRJ</h3>

						<UButton
							to="https://www.srij.turismodeportugal.pt/pt/jogo-responsavel/como-jogar-de-forma-responsavel"
							target="_blank"
							icon="ph:arrow-square-out"
							size="sm"
							color="primary"
							square
							variant="ghost"
							class="text-xl shrink-0"
							@click="
								sendEventExternalLink({
									link_name: 'SIDRJ',
									link_url: 'https://www.srij.turismodeportugal.pt/pt/jogo-responsavel/como-jogar-de-forma-responsavel',
								})
							"
						/>
					</div>
					<div class="space-y-4">
						<p class="text-neutral-700">
							{{
								$t(
									'Control tools, safe gambling guides, and self-exclusion management by the national regulatory authority (SRIJ)',
								)
							}}.
						</p>
						<p class="text-informative-700 font-semibold">{{ $t('Only Portuguese Support Available') }}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="bg-primary-900 w-full h-[72%] hidden sm:block absolute bottom-0 inset-x-0 z-0" />
	</section>
</template>
